import {
  Calendar,
  CalendarCheck,
  CheckCircle,
  Clock,
  Eye,
  Info,
  Sliders,
} from "@tamagui/lucide-icons";
import type { LearnAboutInfo } from "../LearnScreen";

export const CalendarLearnMore: LearnAboutInfo[] = [
  {
    titleIcon: Calendar,
    title: "Dates",
    subtitle: "Find out when everyone is free",
    image: require("../../../../web_legacy/static/calendar_card_preview.webp"),
    featureList: [
      {
        icon: CalendarCheck,
        text: "1. Enter when you are available",
      },
      {
        icon: Clock,
        text: "2. Wait for everyone to do the same",
      },
      {
        icon: CheckCircle,
        text: "3. Select the dates final dates together",
      },
      {
        icon: Eye,
        text: "4. See the final dates on the overview",
      },
    ],
    descriptions: [
      {
        icon: Info,
        title: "What is it?",
        description:
          "Coordinate availability with ease using Planira's visual calendar, where everyone can select and share their free dates.",
      },

      {
        icon: Sliders,
        title: "Extra options",
        description:
          "You can also limit what time range that are available to select in the Calendar through the extra options.",
      },
    ],
  },
];
